import React, { useState } from 'react';
import { Input, Button, Typography, Spin, Card } from 'antd';

const { TextArea } = Input;
const { Title, Text } = Typography;

const MistralComponent = () => {
  const [query, setQuery] = useState('');
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleQueryChange = ({ target: { value } }) => setQuery(value);

  const submitQuery = async () => {
    setError('');
    setAnswer('');
    setIsLoading(true);

    try {
      const response = await fetch('http://localhost:3001/api/mistral', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const data = await response.json();
      setAnswer(data.response);
    } catch (err) {
      console.error(err);
      setError('Ett fel uppstod vid bearbetning av din förfrågan. Försök igen senare.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Title>Ställ en fråga</Title>
      <TextArea rows={4} value={query} onChange={handleQueryChange} placeholder="Skriv din fråga här..." disabled={isLoading} />
      <Button type="primary" onClick={submitQuery} style={{ marginTop: '20px' }} disabled={isLoading}>
        Skicka
      </Button>
      <div style={{ position: 'relative', height: '50px' }}>
        {isLoading && (
          <Spin size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} />
        )}
      </div>
      {error && <div style={{ color: 'red', marginTop: '20px' }}>{error}</div>}
      {answer && (
        <Card style={{ borderRadius: '5px' }}>
          <Text strong>Svar:</Text>
          <p style={{ marginTop: '10px' }}>{answer}</p>
        </Card>
      )}
    </div>
  );
};

export default MistralComponent;
